"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class CustomField extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'customField';
        this._customFieldTypeId = initParams.custom_field_type_id;
        this._customFieldType = initParams.custom_field_type;
        this._customFieldName = initParams.custom_field_name;
        this._siteIds = (0, util_1.camelArray)(initParams.site_ids);
        this._icon = initParams.icon;
        this._colour = initParams.colour;
        this._valueText = initParams.value_text;
        this._valueNumber = initParams.value_number;
        this._valueBoolean = initParams.value_boolean;
        this._valueTimestamp = initParams.value_timestamp;
        this.__permission = initParams._permission;
    }
    set customFieldTypeId(value) {
        console.error('Do not set objects this way');
    }
    setCustomFieldTypeId(value) {
        return this.dataService.updateCustomField(this.id, { custom_field_type_id: value }, this);
    }
    get customFieldTypeId() {
        return this._customFieldTypeId;
    }
    set customFieldType(value) {
        console.error('Do not set objects this way');
    }
    setCustomFieldType(value) {
        return this.dataService.updateCustomField(this.id, { custom_field_type: value }, this);
    }
    get customFieldType() {
        return this._customFieldType;
    }
    set customFieldName(value) {
        console.error('Do not set objects this way');
    }
    setCustomFieldName(value) {
        return this.dataService.updateCustomField(this.id, { custom_field_name: value }, this);
    }
    get customFieldName() {
        return this._customFieldName;
    }
    set siteIds(value) {
        console.error('Do not set objects this way');
    }
    setSiteIds(value) {
        return this.dataService.updateCustomField(this.id, { site_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get siteIds() {
        return this._siteIds;
    }
    set icon(value) {
        console.error('Do not set objects this way');
    }
    setIcon(value) {
        return this.dataService.updateCustomField(this.id, { icon: value }, this);
    }
    get icon() {
        return this._icon;
    }
    set colour(value) {
        console.error('Do not set objects this way');
    }
    setColour(value) {
        return this.dataService.updateCustomField(this.id, { colour: value }, this);
    }
    get colour() {
        return this._colour;
    }
    set valueText(value) {
        console.error('Do not set objects this way');
    }
    setValueText(value) {
        return this.dataService.updateCustomField(this.id, { value_text: value }, this);
    }
    get valueText() {
        return this._valueText;
    }
    set valueNumber(value) {
        console.error('Do not set objects this way');
    }
    setValueNumber(value) {
        return this.dataService.updateCustomField(this.id, { value_number: value }, this);
    }
    get valueNumber() {
        return this._valueNumber;
    }
    set valueBoolean(value) {
        console.error('Do not set objects this way');
    }
    setValueBoolean(value) {
        return this.dataService.updateCustomField(this.id, { value_boolean: value }, this);
    }
    get valueBoolean() {
        return this._valueBoolean;
    }
    set valueTimestamp(value) {
        console.error('Do not set objects this way');
    }
    setValueTimestamp(value) {
        return this.dataService.updateCustomField(this.id, { value_timestamp: value }, this);
    }
    get valueTimestamp() {
        return this._valueTimestamp;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateCustomField(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateCustomField(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteCustomField(this.id, this);
    }
}
exports.default = CustomField;
//# sourceMappingURL=customField.js.map